module.exports = {"stripeKey":"pk_test_DbrzZOIMFypE9U5xHo6AnoDS","stripeOptions":{}}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/config/stripe.json
// module id = IEfP
// module chunks = 1